<script>
    import { onMount } from 'svelte';

    // paramètres bind
    export let oneResult, counter, resultUsernameId, gameNameColor;
    let backgroundColor, borderColor = "";

    onMount(() => {
        let c = counter + 1;
        switch (c) {
            case 1:
                backgroundColor = "bg-podium-gold";
                break;
            case 2:
                backgroundColor = "bg-podium-iron";
                break;
            case 3:
                backgroundColor = "bg-podium-bronze";
                break;
            default:
                backgroundColor = "bg-beige";
        }
        borderColor = `border-${gameNameColor}`;
    })
</script>

<style>
    .ms {
        @apply text-sm font-normal ml-0.5;
    }
    .ranking-one-result {
        @apply grid mx-2.5 my-2 px-1.5 py-2;
        grid-template-columns: 0.12fr 0.3fr 1fr;
    }
    .is-old-result {
        @apply border-solid border-4;
    }
</style>

<div class="ranking-one-result {backgroundColor} {borderColor}" class:is-old-result="{resultUsernameId == oneResult._id}">
    <div class="flex justify-center items-center text-3xl font-semibold">
        {counter+1}
    </div>
    <div class="flex text-center flex-col justify-center px-1.5">
        <div class="capitalize text-lg">{oneResult.username}</div>
        <div class="text-xl font-medium">{oneResult.time_reaction}<span class="ms">ms</span></div>
    </div>
    <!-- <div class="flex flex-col justify-center text-center">
        <div class="flex justify-center items-center">
            <div class="text-sm">Temps de réaction moyen</div>
            <div class="ml-1.5 text-lg font-medium">{oneResult.average_time_reaction}<span class="ms">ms</span></div>
        </div>
        <div class="flex justify-center items-center">
            <div class="text-sm">Meilleur temps de réaction</div>
            <div class="ml-1.5 text-lg font-medium">{oneResult.best_time_reaction}<span class="ms">ms</span></div>
        </div>
    </div> -->
</div>